<template>
    <div class="pa-t-40 bg-round bg-fff">
        <div class="container">
            <Bread/>
        </div>
        
        <div class="container vhtml">
            <div v-html="detail.Content"></div>
        </div>

    </div>
</template>
<style lang="scss" scoped>
.vhtml{
    margin: 0 auto;
    width: 680px;
    line-height: 35px;
    padding: 0 20px;
}
</style>
<script>
    import {getOther} from "../api.js";
    export default {
        name: "merge",
        data() {
            return {
                detail:"",
            };
        },
        created() {
            console.log("开始开发")
            this.getDetail();
        },
        
        methods: {
            //获取数据
            getDetail() {
                let data = {
                    code: "AICreativeImaging",
                };
                getOther(data).then((res) => {
                    console.log(res);
                    this.detail = res.data.Data;
                });
            }
        },
    };
</script>
